import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { countryCityActions } from "../../../redux/actions/countryCityActions";
import {
  get_merchant_list,
  get_merchant_details_id
} from "../../../redux/actions/merchantActions";
import { getPayoutList } from "../../../redux/actions/payoutActions";
import {
  add_contract,
  getContractDetails,
  update_contract,
  clone_contract
} from "../../../redux/actions/contractActions";
import { getSalesPersons } from "../../../redux/actions/salesPersonActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-datepicker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "react-datepicker/dist/react-datepicker.css";
import auth from "../../../services/auth";

import AdditionalPrice from "./AdditionalPrice";
import Attributes from "./Attributes";
import {aclUtil} from "../../util";
import NumberFormat from "react-number-format";

let rand = require("random-key"),
xCoordinate = {},
yCoordinate = {};

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  countries: PropTypes.array.isRequired,
  get_merchant_list: PropTypes.func.isRequired,
  getContractDetails: PropTypes.func.isRequired,
  update_contract: PropTypes.func.isRequired,
  clone_contract: PropTypes.func.isRequired,
  get_merchant_details_id: PropTypes.func.isRequired
};

let cityItems = [];
let isLoading = "false";
let userinfo = "";
let priceIndex = 0;
let form = [];
let offerTitle = [],
  expirationMonth = [],
  expirationDate = [],
  minQuantity = [],
  skuCode = [],
  maxPerCustomer = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  incrementalRedemption = [],
  maxAsGift = [],
  attributeData = [],
  contractID = [];
let additionalPriceDetail = [],
  contractIdParams,
  contractTypeParams,
  contract,
  matrixData = [],
  vouchers = [];

class AddContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ADD_CONTRACT',
      path: ["Home", "Manage Contract", "Add New"],
      links:["home", "contractList",'addContract'],
      startDate: moment(),
      countryData: [],
      statesName: [],
      citiesName: [],
      contractID: "",
      cityID: "",
      offerTitle: "",
      maxAvailable: "",
      retailPrice: "",
      offerPrice: "",
      remittance: "",
      maxPerCustomer: "",
      maxAsGift: "",
      incrementalRedemption: "0",
      expirationMonth: "",
      expirationDate: "",
      minQuantity: "1",
      skuCode: "",
      merchantID: "",
      merchantLegalName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      phone: "",
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      termsAndConditions: "",
      redeemedAtCall: "0",
      shipable: "0",
      redemptionCodeReq: "0",
      vouchersBeIssued: "instantly",
      alertMessage: "",
      countryName: "United States",
      coupoOption: false,
      service: "",
      pricing: "",
      creditCardType: "",
      creditCardNumber: "",
      cardExpirationDate: "",
      securityNumber: "",
      affiliateOption: false,
      affiliatePurchaseUrl: "",
      paymentType: "Fixed Fee",
      paymentAmount: "",
      paymentReceived: "0",
      paymentAmountReceived: "",
      paymentAmountReceivedStatus: false,
      contractType: "1",
      disabled: false,
      submitValue: "Save",
      show: false,
      changeDate: false,
      salesManagerID: "",
      salespersonlist: [],
      priceIndex: [],
      attributeStatus: false,
      merchantOffer: "",
      attributes: [],
      clearAttributes: false,
      payoutList: '',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateDates = this.handleUpdateDates.bind(this);
    this.handleChangeMerchant = this.handleChangeMerchant.bind(this);
    this.handleChangeContract = this.handleChangeContract.bind(this);
    this.handlePaymentReceived = this.handlePaymentReceived.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.addPricingDetail = this.addPricingDetail.bind(this);
  }
  /*
   * Start multiple price management
   */

  AttributeStatus = () => {
    this.setState({ attributeStatus: true });
  };
  addPricingDetail = e => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        affiliateOption={this.state.affiliateOption}
        handleOfferChange={this.handleOfferChange}
        handleexpirationMonthChange={this.handleexpirationMonthChange}
        handleexpirationDateChange={this.handleexpirationDateChange}
        handleminQuantityChange={this.handleminQuantityChange}
        handleskuCodeChange={this.handleskuCodeChange}
        handlemaxPerCustomerChange={this.handlemaxPerCustomerChange}
        handlemaxAvailableChange={this.handlemaxAvailableChange}
        handleretailPriceChange={this.handleretailPriceChange}
        handleofferPriceChange={this.handleofferPriceChange}
        handleremittanceChange={this.handleremittanceChange}
        handleincrementalRedemptionChange={
          this.handleincrementalRedemptionChange
        }
        handleGenerateVoucher={this.handleGenerateVoucher}
        handlemaxAsGiftChange={this.handlemaxAsGiftChange}
        attributeData={this.attributeData}
        priceData=""
        validationError={this.state.additionalError}
        matrixData={this.matrixData}
        key={Math.random()}
      />
    );
    this.setState({ priceIndex: form });
  };

  editPricingDetail = data => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        key={Math.random()}
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        affiliateOption={this.state.affiliateOption}
        handleOfferChange={this.handleOfferChange}
        handleexpirationMonthChange={this.handleexpirationMonthChange}
        handleexpirationDateChange={this.handleexpirationDateChange}
        handleminQuantityChange={this.handleminQuantityChange}
        handleskuCodeChange={this.handleskuCodeChange}
        handlemaxPerCustomerChange={this.handlemaxPerCustomerChange}
        handlemaxAvailableChange={this.handlemaxAvailableChange}
        handleretailPriceChange={this.handleretailPriceChange}
        handleofferPriceChange={this.handleofferPriceChange}
        handleremittanceChange={this.handleremittanceChange}
        handleincrementalRedemptionChange={
          this.handleincrementalRedemptionChange
        }
        handleGenerateVoucher={this.handleGenerateVoucher}
        handlemaxAsGiftChange={this.handlemaxAsGiftChange}
        attributeData={this.attributeData}
        priceData={data}
        handleUpdate={this.handleUpdate}
        validationError={this.state.additionalError}
        matrixData={this.matrixData}
      />
    );
    this.setState({ priceIndex: form });
  };

  handleUpdate = (field, value, index) => {
    let newIdx = index - 1;
    const newContract = this.state.contract.map((data, pidx) => {
      if (newIdx !== pidx) return data;
      return { ...data, [field]: value };
    });

    this.setState({ contract: newContract });
  };

  handleChangeAditionalPrice = e => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name == "offerTitle") {
      this.handleOfferChange(e.target.value, 0);
    }
    if (e.target.name == "expirationMonth") {
      this.handleexpirationMonthChange(e.target.value, 0);
    }
    if (e.target.name == "expirationDate") {
      this.handleexpirationDateChange(e.target.value, 0);
    }
    if (e.target.name == "minQuantity") {
      this.handleminQuantityChange(e.target.value, 0);
    }
    if (e.target.name == "skuCode") {
      this.handleskuCodeChange(e.target.value, 0);
    }
    if (e.target.name == "maxPerCustomer") {
      this.handlemaxPerCustomerChange(e.target.value, 0);
    }
    if (e.target.name == "maxAvailable") {
      this.handlemaxAvailableChange(e.target.value, 0);
    }
    if (e.target.name == "retailPrice") {
      this.handleretailPriceChange(e.target.value, 0);
    }
    if (e.target.name == "offerPrice") {
      this.handleofferPriceChange(e.target.value, 0);
    }
    if (e.target.name == "remittance") {
      this.handleremittanceChange(e.target.value, 0);
    }
    if (e.target.name == "incrementalRedemption") {
      this.handleincrementalRedemptionChange(e.target.value, 0);
    }
    if (e.target.name == "vouchers") {
      this.handleGenerateVoucher(e.target.value, 0);
    }
    if (e.target.name == "vouchers"){
      this.handleGenerateVoucher(e.target.value, 0);
    }
    if (e.target.name == "maxAsGift") {
      this.handlemaxAsGiftChange(e.target.value, 0);
    }

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    if (e.target.name === "expirationMonth") {
      if (this.state.expirationMonthError !== "") {
        this.setState({ expirationDateError: "", expirationMonthError: "" });
      }
    }
    if (e.target.name === "expirationDate") {
      if (this.state.expirationDateError !== "") {
        this.setState({ expirationDateError: "", expirationMonthError: "" });
      }
    }
  };

  removePriceDetail = id => {
    let newID = id - 1;
    if (this.state.contract) {
      let contractData = this.state.contract;
      contractData.splice(newID, 1);
      this.setState({ contract: contractData });
    }
    this.state.priceIndex.splice(id, 1);
    offerTitle.splice(id, 1);
    expirationMonth.splice(id, 1);
    expirationDate.splice(id, 1);
    minQuantity.splice(id, 1);
    skuCode.splice(id, 1);
    maxPerCustomer.splice(id, 1);
    maxAvailable.splice(id, 1);
    retailPrice.splice(id, 1);
    offerPrice.splice(id, 1);
    remittance.splice(id, 1);
    incrementalRedemption.splice(id, 1);
    maxAsGift.splice(id, 1);
    this.setState({ priceIndex: this.state.priceIndex });
    priceIndex = priceIndex - 1;
  };

  handleContractIDChange = (data, idx) => {
    contractID[idx] = data;
  };

  handleOfferChange = (offerTitleData, idx) => {
    offerTitle[idx] = offerTitleData;
  };
  handleexpirationMonthChange = (expirationMonthData, idx) => {
    expirationMonth[idx] = expirationMonthData;
  };
  handleexpirationDateChange = (expirationDateData, idx) => {
    expirationDate[idx] = expirationDateData;
  };
  handleminQuantityChange = (minQuantityData, idx) => {
    minQuantity[idx] = minQuantityData;
  };
  handleskuCodeChange = (skuCodeData, idx) => {
    skuCode[idx] = skuCodeData;
  };
  handlemaxPerCustomerChange = (maxPerCustomerData, idx) => {
    maxPerCustomer[idx] = maxPerCustomerData;
  };
  handlemaxAvailableChange = (maxAvailableData, idx) => {
    maxAvailable[idx] = maxAvailableData;
  };
  handleretailPriceChange = (retailPriceData, idx) => {
    retailPrice[idx] = retailPriceData;
  };
  handleofferPriceChange = (offerPriceData, idx) => {
    offerPrice[idx] = offerPriceData;
  };
  handleremittanceChange = (remittanceData, idx) => {
    remittance[idx] = remittanceData;
  };
  handleincrementalRedemptionChange = (incrementalRedemptionData, idx) => {
    incrementalRedemption[idx] = incrementalRedemptionData;
  };
  handleGenerateVoucher = (vouchersData, idx) => {
    vouchers[idx] = vouchersData;
  };
  handlemaxAsGiftChange = (maxAsGiftData, idx) => {
    maxAsGift[idx] = maxAsGiftData;
    let result = maxAsGift.some(el => el > 0);
    if(result){
      this.setState({redeemedAtCall: 1});
    }else{
      this.setState({redeemedAtCall: 0});
    }
  };

  attributeData = (data, idx) => {
    attributeData[idx] = data;
  };

  matrixData = (data, idx) => {
    matrixData[idx] = data;
  };

  /*
   * End multiple price management
   */

  handleUpdateDates(date) {
    this.setState({ disabled: false });
    const dates = moment();
    if (date) {
      const dates = date;
      this.setState({
        startDate: dates,
        changeDate: true,
        expirationMonthError: "",
        expirationDateError: ""
      });
    } else {
      this.setState({
        changeDate: false
      });
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePaymentReceived(e) {
    this.setState({ disabled: false });
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "1") {
      this.setState({ paymentAmountReceivedStatus: true });
    } else {
      this.setState({ paymentAmountReceivedStatus: false });
    }
  }

  handleChangeMerchant(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({
      merchantLegalName: "",
      address1: "",
      address2: "",
      phone: "",
      contactEmail: "",
      contactPhone: "",
      contactName: "",
      zip: "",
      city: "",
      country: "",
      cityID: "",
      state: ""
    });
    this.props.get_merchant_details_id(e.target.value, localStorage.getItem("siteID"));
  }

  handleChangeContract(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "6") {
      this.setState({ coupoOption: true });
      this.setState({ affiliateOption: false });
    } else if (e.target.value === "7") {
      this.setState({ coupoOption: false });
      this.setState({ affiliateOption: true });
    } else {
      this.setState({ coupoOption: false });
      this.setState({ affiliateOption: false });
    }
  }

  // Handle input onchange
  handleChange(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    xCoordinate = {}
    yCoordinate = {}


    if (this.state.merchantOffer.length === 0) {
      isError = true;
      this.setState({ merchantOfferError: "red" });
      if(xCoordinate.key !== 'formmerchantTitle'){
        let x = window.scrollX + document.querySelector('#formmerchantTitle').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formmerchantTitle').getBoundingClientRect().top - 89
        xCoordinate['formmerchantTitle'] = x;
        yCoordinate['formmerchantTitle'] = y;
      }
    }

    if (this.state.offerTitle.length === 0) {
      isError = true;
      this.setState({ offerTitleError: "red" });
      if(xCoordinate.key !== 'formOfferTitle'){
        let x = window.scrollX + document.querySelector('#formOfferTitle').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formOfferTitle').getBoundingClientRect().top - 89
        xCoordinate['formOfferTitle'] = x;
        yCoordinate['formOfferTitle'] = y;
      }
    }
    if (this.state.maxAvailable.length === 0) {
      isError = true;
      this.setState({ maxAvailableError: "red" });
      if(xCoordinate.key !== 'formMaxAvailable'){
        let x = window.scrollX + document.querySelector('#formMaxAvailable').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formMaxAvailable').getBoundingClientRect().top - 89
        xCoordinate['formMaxAvailable'] = x;
        yCoordinate['formMaxAvailable'] = y;
      }
    }

    if (this.state.retailPrice.length === 0) {
      isError = true;
      this.setState({ retailPriceError: "red" });
      if(xCoordinate.key !== 'formRetailPrice'){
        let x = window.scrollX + document.querySelector('#formRetailPrice').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formRetailPrice').getBoundingClientRect().top - 89
        xCoordinate['formRetailPrice'] = x;
        yCoordinate['formRetailPrice'] = y;
      }
    }
    if (this.state.offerPrice.length === 0) {
      isError = true;
      this.setState({ offerPriceError: "red" });
      if(xCoordinate.key !== 'formOfferPrice'){
        let x = window.scrollX + document.querySelector('#formOfferPrice').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formOfferPrice').getBoundingClientRect().top - 89
        xCoordinate['formOfferPrice'] = x;
        yCoordinate['formOfferPrice'] = y;
      }
    }

    if (!this.state.merchantID) {
      isError = true;
      this.setState({ merchantIDError: "red" });
      if(xCoordinate.key !== 'formMerchantID'){
        let x = window.scrollX + document.querySelector('#formMerchantID').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formMerchantID').getBoundingClientRect().top - 89
        xCoordinate['formMerchantID'] = x;
        yCoordinate['formMerchantID'] = y;
      }
    }

    if (!this.state.expirationMonth && !this.state.expirationDate) {
      isError = true;
      this.setState({
        expirationMonthError: "red",
        expirationDateError: "red"
      });
      if(xCoordinate.key !== 'formExpirationMonth'){
        let x = window.scrollX + document.querySelector('#formExpirationMonth').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formExpirationMonth').getBoundingClientRect().top - 89
        xCoordinate['formExpirationMonth'] = x;
        yCoordinate['formExpirationMonth'] = y;
      }
      if(xCoordinate.key !== 'formExpirationDate'){
        let x = window.scrollX + document.querySelector('#formExpirationDate').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formExpirationDate').getBoundingClientRect().top - 89
        xCoordinate['formExpirationDate'] = x;
        yCoordinate['formExpirationDate'] = y;
      }
    }

    if (this.state.affiliateOption === false) {
      if (!this.state.remittance) {
        isError = true;
        this.setState({ remittanceError: "red" });
        if(xCoordinate.key !== 'formMinQuantity'){
          let x = window.scrollX + document.querySelector('#formMinQuantity').getBoundingClientRect().left
          let y = window.scrollY + document.querySelector('#formMinQuantity').getBoundingClientRect().top - 89
          xCoordinate['formMinQuantity'] = x;
          yCoordinate['formMinQuantity'] = y;
        }
      }

      if(!this.state.payment_term_id){
        isError = true;
        this.setState({payment_term_idError: 'red'})
      }

      if (this.state.maxAsGift === '') {
        isError = true;
        this.setState({ maxAsGiftError: "red" });
        if(xCoordinate.key !== 'formMaxAsGift'){
          let x = window.scrollX + document.querySelector('#formMaxAsGift').getBoundingClientRect().left
          let y = window.scrollY + document.querySelector('#formMaxAsGift').getBoundingClientRect().top - 89
          xCoordinate['formMaxAsGift'] = x;
          yCoordinate['formMaxAsGift'] = y;
        }
      }
    }

    return isError;
  };

  additionalPrice = () => {
    additionalPriceDetail = [];
    let constAdditionalData;
    // contractID
    if (contractIdParams == "") {
      for (let i = 0; i < offerTitle.length; i++) {
        constAdditionalData = {
          offerTitle: offerTitle[i] ? offerTitle[i] : "",
          expirationMonth: expirationMonth[i] ? expirationMonth[i] : "",
          expirationDate: expirationDate[i] ? expirationDate[i] : "",
          minQuantity: minQuantity[i] ? minQuantity[i] : "",
          skuCode: skuCode[i] ? skuCode[i] : "",
          maxPerCustomer: maxPerCustomer[i] ? maxPerCustomer[i] : "",
          maxAvailable: maxAvailable[i] ? maxAvailable[i] : "",
          retailPrice: retailPrice[i] ? retailPrice[i] : "",
          offerPrice: offerPrice[i] ? offerPrice[i] : "",
          remittance: remittance[i] ? remittance[i] : "",
          incrementalRedemption: incrementalRedemption[i]
            ? incrementalRedemption[i]
            : "",
          vouchers: vouchers[i] ? vouchers[i] : "",
          maxAsGift: maxAsGift[i] ? maxAsGift[i] : "",
          attributes: attributeData[i] ? attributeData[i] : [],
          metrix: matrixData[i] ? matrixData[i] : "",
        };
        additionalPriceDetail.push(constAdditionalData);
      }
    } else {
      for (let i = 0; i < offerTitle.length; i++) {
        constAdditionalData = {
          contractID: contractID[i] ? contractID[i] : "",
          offerTitle: offerTitle[i] ? offerTitle[i] : "",
          expirationMonth: expirationMonth[i] ? expirationMonth[i] : "",
          expirationDate: expirationDate[i] ? expirationDate[i] : "",
          minQuantity: minQuantity[i] ? minQuantity[i] : "",
          skuCode: skuCode[i] ? skuCode[i] : "",
          maxPerCustomer: maxPerCustomer[i] ? maxPerCustomer[i] : "",
          maxAvailable: maxAvailable[i] ? maxAvailable[i] : "",
          retailPrice: retailPrice[i] ? retailPrice[i] : "",
          offerPrice: offerPrice[i] ? offerPrice[i] : "",
          remittance: remittance[i] ? remittance[i] : "",
          incrementalRedemption: incrementalRedemption[i]
            ? incrementalRedemption[i]
            : "",
          vouchers: vouchers[i] ? vouchers[i] : "",
          maxAsGift: maxAsGift[i] ? maxAsGift[i] : "",
          attributes: attributeData[i] ? attributeData[i] : [],
          metrix: matrixData[i] ? matrixData[i] : ""
        };
        additionalPriceDetail.push(constAdditionalData);
      }

      if (this.state.contract) {
        this.state.contract.map((data, index) =>{
          if(data.attribute){
            data.attributes = (data.attribute) ? data.attribute : [];
            delete data["attribute"];
            additionalPriceDetail.push(data);
          }else{
            additionalPriceDetail.push(data);
          }      
        });
      }
    }
    this.setState({ deatil: additionalPriceDetail });
    return additionalPriceDetail;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    const additionalPrice = this.additionalPrice();
    if (!err) {
      this.setState({ disabled: true });
      const date = this.state.expirationDate ? this.state.expirationDate : null;
      if (this.state.contractID !== "") {
      if (contractIdParams !== "" && contractTypeParams == 'edit') {
         const postData = {
          proposal_type: this.state.contractType,
          affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
          paymentType: this.state.paymentType,
          paymentAmount: this.state.paymentAmount,
          paymentReceived: this.state.paymentReceived,
          paymentAmountReceived: this.state.paymentAmountReceived,
          service: this.state.service,
          price: this.state.pricing,
          creditCardType: this.state.creditCardType,
          creditCardNumber: this.state.creditCardNumber,
          cardExpirationDate: this.state.cardExpirationDate,
          securityNumber: this.state.securityNumber,
          cityID: this.state.cityID,
          merchantOffer: this.state.merchantOffer,
          detail: additionalPrice,
          merchantID: this.state.merchantID,
          merchantLegalName: this.state.merchantLegalName,
          address1: this.state.address1,
          address2: this.state.address2,
          city: this.state.city ? this.state.city : "",
          state: this.state.state ? this.state.state : "",
          country: this.state.country ? this.state.country : "",
          zip: this.state.zip,
          phone: this.state.phone,
          contactName: this.state.contactName,
          contactPhone: this.state.contactPhone,
          contactEmail: this.state.contactEmail,
          termsAndConditions: this.state.termsAndConditions,
          redeemedAtCall: this.state.redeemedAtCall,
          shipable: this.state.shipable,
          redemptionCodeReq: this.state.redemptionCodeReq,
          vouchersBeIssued: this.state.vouchersBeIssued,
          salesManagerID: this.state.salesManagerID,
          payment_term_id: this.state.payment_term_id,
          site_id: localStorage.getItem("siteID")
          // actionType: actionType,
        };

         this.props.update_contract(postData);
      }
      else if (contractIdParams !== "" && contractTypeParams == 'clone') {

        const postData = {
          cloneContractID: this.state.contractID,
          proposal_type: this.state.contractType,
          affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
          paymentType: this.state.paymentType,
          paymentAmount: this.state.paymentAmount,
          paymentReceived: this.state.paymentReceived,
          paymentAmountReceived: this.state.paymentAmountReceived,
          service: this.state.service,
          price: this.state.pricing,
          creditCardType: this.state.creditCardType,
          creditCardNumber: this.state.creditCardNumber,
          cardExpirationDate: this.state.cardExpirationDate,
          securityNumber: this.state.securityNumber,
          cityID: this.state.cityID,
          merchantOffer: this.state.merchantOffer,
          detail: additionalPrice,
          merchantID: this.state.merchantID,
          merchantLegalName: this.state.merchantLegalName,
          address1: this.state.address1,
          address2: this.state.address2,
          city: this.state.city ? this.state.city : "",
          state: this.state.state ? this.state.state : "",
          country: this.state.country ? this.state.country : "",
          zip: this.state.zip,
          phone: this.state.phone,
          contactName: this.state.contactName,
          contactPhone: this.state.contactPhone,
          contactEmail: this.state.contactEmail,
          termsAndConditions: this.state.termsAndConditions,
          redeemedAtCall: this.state.redeemedAtCall,
          shipable: this.state.shipable,
          redemptionCodeReq: this.state.redemptionCodeReq,
          vouchersBeIssued: this.state.vouchersBeIssued,
          salesManagerID: this.state.salesManagerID,
          payment_term_id: this.state.payment_term_id,
          site_id: localStorage.getItem("siteID")
          // actionType: actionType,
        };
        this.props.clone_contract(postData);
      }

        


      } else {
        const postData = {
          proposal_type: this.state.contractType,
          affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
          paymentType: this.state.paymentType,
          paymentAmount: this.state.paymentAmount,
          paymentReceived: this.state.paymentReceived,
          paymentAmountReceived: this.state.paymentAmountReceived,
          service: this.state.service,
          price: this.state.pricing,
          creditCardType: this.state.creditCardType,
          creditCardNumber: this.state.creditCardNumber,
          cardExpirationDate: this.state.cardExpirationDate,
          securityNumber: this.state.securityNumber,
          cityID: this.state.cityID,
          merchantOffer: this.state.merchantOffer,
          detail: additionalPrice,
          merchantID: this.state.merchantID,
          merchantLegalName: this.state.merchantLegalName,
          address1: this.state.address1,
          address2: this.state.address2,
          city: this.state.city ? this.state.city : "",
          state: this.state.state ? this.state.state : "",
          country: this.state.country ? this.state.country : "",
          zip: this.state.zip,
          phone: this.state.phone,
          contactName: this.state.contactName,
          contactPhone: this.state.contactPhone,
          contactEmail: this.state.contactEmail,
          termsAndConditions: this.state.termsAndConditions,
          redeemedAtCall: this.state.redeemedAtCall,
          shipable: this.state.shipable,
          redemptionCodeReq: this.state.redemptionCodeReq,
          vouchersBeIssued: this.state.vouchersBeIssued,
          salesManagerID: this.state.salesManagerID,
          payment_term_id: this.state.payment_term_id,
          site_id: localStorage.getItem("siteID")

        };
        this.props.add_contract(postData);
      }
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
      }
    }
  }

  Clear() {
    (this.state.contractType = "1"),
      (this.state.affiliatePurchaseUrl = ""),
      (this.state.paymentType = ""),
      (this.state.paymentAmount = ""),
      (this.state.paymentReceived = ""),
      (this.state.paymentAmountReceived = ""),
      (this.state.service = ""),
      (this.state.pricing = ""),
      (this.state.creditCardType = ""),
      (this.state.creditCardNumber = ""),
      (this.state.cardExpirationDate = ""),
      (this.state.securityNumber = ""),
      (this.state.cityID = ""),
      (this.state.merchantID = ""),
      (this.state.merchantLegalName = ""),
      (this.state.address1 = ""),
      (this.state.address2 = ""),
      (this.state.zip = ""),
      (this.state.phone = ""),
      (this.state.contactName = ""),
      (this.state.contactPhone = ""),
      (this.state.contactEmail = ""),
      (this.state.termsAndConditions = ""),
      (this.state.redeemedAtCall = ""),
      (this.state.shipable = ""),
      (this.state.redemptionCodeReq = ""),
      (this.state.vouchersBeIssued = "");

    (this.state.merchantOffer = ""),
      (this.state.offerTitle = ""),
      (this.state.maxAvailable = ""),
      (this.state.retailPrice = ""),
      (this.state.offerPrice = ""),
      (this.state.remittance = ""),
      (this.state.maxPerCustomer = ""),
      (this.state.maxAsGift = ""),
      (this.state.incrementalRedemption = ""),
      (this.state.expirationMonth = ""),
      (this.state.startDate = ""),
      (this.state.minQuantity = ""),
      (this.state.skuCode = ""),
      (this.state.contract = ""),
      (this.state.salesManagerID = ""),
      this.setState({ attributes: "" }),
      (attributeData = []);
   
    additionalPriceDetail = [];
    priceIndex = 0;
    priceIndex = [];
    offerTitle = [];
    expirationMonth = [];
    expirationDate = [];
    minQuantity = [];
    skuCode = [];
    maxPerCustomer = [];
    maxAvailable = [];
    retailPrice = [];
    offerPrice = [];
    remittance = [];
    incrementalRedemption = [];
    maxAsGift = [];
    form = [];
    this.state.priceIndex = [];
    // contract="";
  }

  onSelectedCountry = (val, key) => {
    this.setState({ disabled: false });
    this.setState({ country: val });
    if(this.state.country != val){
      this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
    }
  };

  onSelectedState = (val, key) => {
    this.setState({ disabled: false });
    this.setState({ state: val });
  };

  onSelectedCity = (val, key) => {
    this.setState({ disabled: false });
    this.setState({ city: val });
    this.setState({ cityID: key });
  };

  handlePageChange = page => {
    this.props.get_merchant_list({ page: 0, site_id: localStorage.getItem("siteID") });
  };

  componentDidMount() {
    this.handlePageChange();
  }

  componentWillMount() {
    userinfo = auth.getUserInfo();

    this.props.clearAlert();
    this.handleDismiss();
    this.props.getSalesPersons({site_id: localStorage.getItem("siteID")});
    this.props.getPayoutList({site_id: localStorage.getItem("siteID")});

    contractIdParams = this.props.match.params.contractId
      ? this.props.match.params.contractId
      : "";

    contractTypeParams = this.props.match.params.cType ? this.props.match.params.cType : "";
    if(this.props.match.params.contractId && this.props.match.params.cType){
      const editLink = `addContract/${this.props.match.params.contractId}/${this.props.match.params.cType}`
      const path = ["Home", "Manage Contract", "Edit Offer"];
      const links = ["home","contractList",editLink];
      this.setState({path:path, links:links})
    }
    if (contractIdParams !== "" && contractTypeParams == 'edit') {
      isLoading = "true";
      this.props.getContractDetails(contractIdParams, localStorage.getItem("siteID"));
      // this.state.path = ["Home", "Manage Offer", "Edit Offer"];
      // this.state.links = ["home","contractList",editLink]
    }
    else if (contractIdParams !== "" && contractTypeParams == 'clone') {
      isLoading = "true";
      this.props.getContractDetails(contractIdParams, localStorage.getItem("siteID"));
      // this.state.path = ["Home", "Manage Offer", "Edit Offer"];
      // this.state.links = ["home","contractList",editLink]
    }
    else 
    {
      this.setState({ merchantID: contractIdParams });
      this.props.get_merchant_details_id(contractIdParams, localStorage.getItem("siteID"));
    }
  }

  componentWillReceiveProps(nextProps) {
    let menuAclKey = this.state.menuKey;
    if(this.props.match.params.cType == 'edit'){
      menuAclKey = 'EDIT_CONTRACT';
    }
    if(!aclUtil.isPrimaryMenuAccessible(menuAclKey)){
      this.props.history.push("/restrictedAccess");
    }

    if (this.props.merchantDetails !== nextProps.merchantDetails) {
      if (nextProps.merchantDetails) {
        isLoading = "false";
        const contactNameConst = `${nextProps.merchantDetails.firstName} ${
          nextProps.merchantDetails.lastName
        }`;

        this.setState({
          merchantLegalName: nextProps.merchantDetails.legalName,
          address1: nextProps.merchantDetails.address1,
          address2: nextProps.merchantDetails.address2,
          phone: nextProps.merchantDetails.phone,
          zip: nextProps.merchantDetails.zipcode,
          city: nextProps.merchantDetails.city,
          country: nextProps.merchantDetails.country,
          cityID: nextProps.merchantDetails.cityID,
          state: nextProps.merchantDetails.state
        });
      }
    }

    if (this.props.addContractResponse !== nextProps.addContractResponse) {
      if (nextProps.addContractResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.addContractResponse.message
        );
        this.setState({ disabled: false });
        isLoading = "false";
        this.state.clearAttributes = true;
        this.onSelectedCountry();
        this.Clear();
      }
      window.scrollTo(0, 0);
    }

    if (this.props.updatedContract !== nextProps.updatedContract) {
      if (nextProps.updatedContract) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedContract.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.cloneContract !== nextProps.cloneContract) {
      if (nextProps.cloneContract) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.cloneContract.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.merchantList !== nextProps.merchantList) {
      if (nextProps.merchantList) {
        this.setState({ merchantList: nextProps.merchantList });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        window.scrollTo(0, 0);
        this.setState({ disabled: false });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }

    if (
      this.props.salesPersonList !== nextProps.salesPersonList &&
      !isEmpty(nextProps.salesPersonList)
    ) {
      this.setState({ salespersonlist: nextProps.salesPersonList.data.data });
    }

    if (this.props.contractDetails !== nextProps.contractDetails) {
      if (nextProps.contractDetails) {
        priceIndex = [];
        isLoading = "false";
        this.setState({ userDetailsForEdit: nextProps.contractDetails });
        let contract = nextProps.contractDetails;
        if (contract.proposal_type === "7") {
          this.setState({ affiliateOption: true });
        } else if (contract.proposal_type === "6") {
          this.setState({ coupoOption: true });
        }
        const expirationMonthConst =
          contract.expirationMonth === null ? "" : contract.expirationMonth;

        this.setState({
          merchantOffer: contract.merchantOffer,
          expirationDate: contract.expirationDate,
          contractID: contract.contractID,
          contractType: contract.proposal_type,
          affiliatePurchaseUrl: contract.affiliatePurchaseUrl,
          paymentType: contract.paymentType,
          paymentAmount: contract.paymentAmount,
          paymentReceived: contract.paymentReceived,
          paymentAmountReceived: contract.paymentAmountReceived,
          service: contract.service,
          pricing: contract.price,
          creditCardType: contract.creditCardType,
          creditCardNumber: contract.creditCardNumber,
          cardExpirationDate: contract.cardExpirationDate,
          securityNumber: contract.securityNumber,
          parentID: contract.parentID,
          offerTitle: contract.offerTitle,
          termsAndConditions: contract.termsAndConditions,
          expirationMonth: expirationMonthConst,
          minQuantity: contract.minQuantity,
          skuCode: contract.skuCode,
          maxAvailable: contract.maxAvailable,
          retailPrice: contract.retailPrice,
          offerPrice: contract.offerPrice,
          remittance: contract.remittance,
          maxPerCustomer: contract.maxPerCustomer,
          maxAsGift: contract.maxAsGift,
          incrementalRedemption: contract.incrementalRedemption,
          vouchers: contract.vouchers,
          merchantID: contract.merchantID,
          merchantLegalName: contract.merchantLegalName,
          address1: contract.address1,
          address2: contract.address2,
          city: contract.city,
          country: contract.country,
          cityID: contract.cityID,
          state: contract.state,
          zip: contract.zip,
          phone: contract.phone,
          contactName: contract.contactName,
          contactEmail: contract.contactEmail,
          contactPhone: contract.contactPhone,
          redeemedAtCall: contract.redeemedAtCall,
          shipable: contract.shipable,
          redemptionCodeReq: contract.redemptionCodeReq,
          vouchersBeIssued: contract.vouchersBeIssued,
          attributes: contract.attribute,
          contract: contract.child_contracts,
          metrix: contract.metrix,
          salesManagerID: contract.salesManagerID,
          payment_term_id: contract.payment_term_id,
        });

        if (!isEmpty(contract.child_contracts)) {
          contract.child_contracts.map((data, index) =>
            this.editPricingDetail(data)
          );
        }

        this.attributeData(contract.attribute, 0);

        if (contract.contractID) {
          this.handleContractIDChange(contract.contractID, 0);
        }

        if (contract.offerTitle) {
          this.handleOfferChange(contract.offerTitle, 0);
        }
        if (contract.expirationMonth) {
          this.handleexpirationMonthChange(contract.expirationMonth, 0);
        }
        if (contract.expirationDate) {
          this.handleexpirationDateChange(contract.expirationDate, 0);
        }
        if (contract.minQuantity) {
          this.handleminQuantityChange(contract.minQuantity, 0);
        }
        if (contract.skuCode) {
          this.handleskuCodeChange(contract.skuCode, 0);
        }
        if (contract.maxPerCustomer) {
          this.handlemaxPerCustomerChange(contract.maxPerCustomer, 0);
        }
        if (contract.maxAvailable) {
          this.handlemaxAvailableChange(contract.maxAvailable, 0);
        }
        if (contract.retailPrice) {
          this.handleretailPriceChange(contract.retailPrice, 0);
        }
        if (contract.offerPrice) {
          this.handleofferPriceChange(contract.offerPrice, 0);
        }
        if (contract.remittance) {
          this.handleremittanceChange(contract.remittance, 0);
        }
        if (contract.incrementalRedemption) {
          this.handleincrementalRedemptionChange(
            contract.incrementalRedemption,
            0
          );
        }
        if(contract.vouchers){
          this.handleGenerateVoucher(
            contract.vouchers,
            0
          );
        }
        if (contract.maxAsGift) {
          this.handlemaxAsGiftChange(contract.maxAsGift, 0);
        }
      }
    }

    if(this.props.payoutList !== nextProps.payoutList){
      if(nextProps.payoutList){
        isLoading="false";
        this.setState({payoutList: nextProps.payoutList.data})
      }
    }
  }

  getValidationOfferTitle() {
    const length = this.state.offerTitle.length;
    if (length < 2) return "error";
    return null;
  }

  getValidationTermsCondition() {
    if (this.state.termsAndConditions) {
      const length = this.state.termsAndConditions.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationminQuantity() {
    const length = this.state.minQuantity.length;
    if (length >= 1) return "success";
    else if (length === 0) return "error";
    return null;
  }

  getValidationskuCode() {
    if (this.state.skuCode) {
      const length = this.state.skuCode.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationmaxPerCustomer() {
    if (this.state.maxPerCustomer) {
      const length = this.state.maxPerCustomer.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationmaxAsGift() {
    if (this.state.maxAsGift) {
      const length = this.state.maxAsGift.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationmaxAvailable() {
    if (this.state.maxAvailable) {
      const length = this.state.maxAvailable.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationretailPrice() {
    const length = this.state.retailPrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationofferPrice() {
    const length = this.state.offerPrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationremittance() {
    const length = this.state.remittance.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationPhoneState() {
    if (this.state.phone) {
      const length = this.state.phone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.phone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationmerchantID() {
    const length = this.state.merchantID.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }
  getValidationcreditCardType() {
    const length = this.state.creditCardType.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationcreditCardNumber() {
    if (this.state.creditCardNumber) {
      const length = this.state.creditCardNumber.length;
      if (length < 16) return "error";
    }

    return null;
  }

  getValidationcardExpirationDate() {
    if (this.state.cardExpirationDate) {
      const length = this.state.cardExpirationDate.length;
      if (length < 4) return "errror";
    }

    return null;
  }

  getValidationsecurityNumber() {
    if (this.state.securityNumber) {
      const length = this.state.securityNumber.length;
      if (length < 3) return "warning";
    }

    return null;
  }

  render() {
    let contract =
      this.props.contractDetails && this.props.contractDetails.merchantLegalName
        ? this.props.contractDetails
        : {};

    let merchantListData = this.state.merchantList
      ? this.state.merchantList
      : [];
    let merchantListItem;

    let countrydata = this.state.countryData ? this.state.countryData : [];
    let countryItems, stateItems, cityItems;

    if (countrydata) {
      countryItems = countrydata.map((countryObject, phyidx) => (
        <option key={phyidx} value={countryObject.country}>
          {countryObject.countryName}
        </option>
      ));
    }

    let salesManagerItems;
    let salespersonData = this.state.salespersonlist
      ? this.state.salespersonlist
      : "";
    if (salespersonData !== "") {
      salesManagerItems = salespersonData.map((salesObject, index) => (
        <option key={index} value={salesObject.user_id}>
          {salesObject.userName}
        </option>
      ));
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.props.sendingMerchantDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Offer Detail</header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="panel-body">
              {isLoading == "true" ? (
                <div className="loader">
                  <p className="loading-message">
                    <i>Loading...</i>
                  </p>
                  <div className="spinner">
                    <div className="dot1" />
                    <div className="dot2" />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={4} xs={12}>
                    <FormGroup controlId="formParentID">
                      <ControlLabel>Contract/Proposal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.contractTypeError }}
                        name="contractType"
                        onChange={this.handleChangeContract}
                        placeholder="select"
                        value={this.state.contractType}
                      >
                        <option value="1">Standard Merchant</option>
                        <option value="2">Premium Merchant</option>
                        <option value="3">Products</option>
                        <option value="4">Travel</option>
                        <option value="5">Events</option>
                        <option value="6">Coupon Offer</option>
                        <option value="7">Affiliate Offer</option>
                        <option value="8">Gift Card Vouchers</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup controlId="formmerchantTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.merchantOffer}
                        placeholder="Title"
                        onChange={this.handleChange}
                        name="merchantOffer"
                        style={{ borderColor: this.state.merchantOfferError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <ControlLabel>Term and Condition</ControlLabel>
                    <FormGroup controlId="formTermsAndConditions">
                      <FormControl
                        style={{
                          borderColor: this.state.termsAndConditionsError
                        }}
                        value={this.state.termsAndConditions}
                        componentClass="textarea"
                        onChange={this.handleChange}
                        name="termsAndConditions"
                        placeholder="Term and Conditions"
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end contract information **/}

          {/**start contract price information **/}
          <div className="panel">
            <header className="panel-heading">
              Pricing Detail{" "}
              <Button
                bsSize="small"
                onClick={this.addPricingDetail}
                bsStyle="success"
                className="pull-right"
              >
                Add Additional Price
              </Button>
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Offer Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.offerTitle}
                        placeholder="Offer Title"
                        onChange={this.handleChangeAditionalPrice}
                        name="offerTitle"
                        style={{ borderColor: this.state.offerTitleError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <FormGroup controlId="formExpirationMonth">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> How Long Until Purchased Vouchers Expire?
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.expirationMonthError }}
                        name="expirationMonth"
                        onChange={this.handleChangeAditionalPrice}
                        value={this.state.expirationMonth}
                        disabled={
                          this.state.expirationDate === "" ||
                          this.state.expirationDate === null
                            ? false
                            : true
                        }
                      >
                        <option value="">None</option>
                        <option value="1">1 Months</option>
                        <option value="2">2 Months</option>
                        <option value="3">3 Months</option>
                        <option value="4">4 Months</option>
                        <option value="5">5 Months</option>
                        <option value="6">6 Months</option>
                        <option value="7">7 Months</option>
                        <option value="8">8 Months</option>
                        <option value="9">9 Months</option>
                        <option value="10">10 Months</option>
                        <option value="11">11 Months</option>
                        <option value="12">12 Months</option>
                        <option value="18">18 Months</option>
                        <option value="0">Never Expires</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formExpirationDate">
                      <ControlLabel>or</ControlLabel>
                      <FormControl
                        className="form-control datepicker"
                        type="date"
                        style={{ borderColor: this.state.expirationDateError }}
                        value={moment(this.state.expirationDate).format(
                          "YYYY-MM-DD"
                        )}
                        placeholder="MM-DD-YYYY"
                        onChange={this.handleChangeAditionalPrice}
                        name="expirationDate"
                        disabled={
                          this.state.expirationMonth === "" ||
                          this.state.expirationMonth === null
                            ? false
                            : true
                        }
                      />
                    </FormGroup>
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>Minimum Quantity Required</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMinQuantity">
                        <FormControl
                          type="text"
                          value={this.state.minQuantity}
                          placeholder="Minimum Quantity Required"
                          onChange={this.handleChangeAditionalPrice}
                          name="minQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        SKU #
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formSkuCode"
                        validationState={this.getValidationskuCode()}
                      >
                        <FormControl
                          type="text"
                          value={this.state.skuCode}
                          placeholder="SKU Code"
                          onChange={this.handleChangeAditionalPrice}
                          name="skuCode"
                          style={{ borderColor: this.state.skuCodeError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                         Max Per Customer
                        (leave blank for an unlimited amount)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formMaxPerCustomer"
                        validationState={this.getValidationmaxPerCustomer()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.maxPerCustomer}
                          placeholder="Max Per Customer"
                          onChange={this.handleChangeAditionalPrice}
                          name="maxPerCustomer"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                  </Col>
                  <Col md={6} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Maximum Available
                    </ControlLabel>
                    <FormGroup controlId="formMaxAvailable">
                      <FormControl
                        type="number"
                        value={this.state.maxAvailable}
                        placeholder="Maximum Available"
                        onChange={this.handleChangeAditionalPrice}
                        name="maxAvailable"
                        style={{ borderColor: this.state.maxAvailableError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Retail Price
                    </ControlLabel>
                    <FormGroup controlId="formRetailPrice">
                      <FormControl
                        type="number"
                        value={this.state.retailPrice}
                        placeholder="Retail Price"
                        onChange={this.handleChangeAditionalPrice}
                        name="retailPrice"
                        style={{ borderColor: this.state.retailPriceError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Offer Price
                    </ControlLabel>
                    <FormGroup controlId="formOfferPrice">
                      <FormControl
                        type="number"
                        value={this.state.offerPrice}
                        placeholder="Offer Price"
                        onChange={this.handleChangeAditionalPrice}
                        name="offerPrice"
                        style={{ borderColor: this.state.offerPriceError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formRemittance">
                        <FormControl
                          type="number"
                          value={this.state.remittance}
                          placeholder="Remittance Per Unit"
                          onChange={this.handleChangeAditionalPrice}
                          name="remittance"
                          style={{ borderColor: this.state.remittanceError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formIncrementalRedemption">
                        <ControlLabel>
                          Will this offer generate multiple vouchers?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="incrementalRedemption"
                          onChange={this.handleChangeAditionalPrice}
                          value={this.state.incrementalRedemption}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    ) : null}
                    {this.state.incrementalRedemption == '1' &&
                    <FormGroup>
                      <ControlLabel>Number of Vouchers to Generate Per Order (each voucher will reflect the retail price divided by the number below. A $25 order / 5 vouchers = $5 value each)</ControlLabel>
                      <FormControl
                        type="number"
                        value={this.state.vouchers}
                        placeholder="Enter Voucher Value"
                        onChange={this.handleChangeAditionalPrice}
                        name="vouchers"
                      />
                    </FormGroup>
                    }
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Max As Gifts (Do
                        not leave blank. Add 0 for no additional vouchers. No
                        unlimited option)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formMaxAsGift"
                        validationState={this.getValidationmaxAsGift()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.maxAsGift}
                          placeholder="Max As Gifts"
                          onChange={this.handleChangeAditionalPrice}
                          name="maxAsGift"
                          style={{ borderColor: this.state.maxAsGiftError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                  </Col>
                </Row>
              
                {/* {!this.state.attributeStatus &&
                isEmpty(this.state.attributes) ? (
                  <Button
                    bsSize="small"
                    onClick={this.AttributeStatus}
                    bsStyle="success"
                  >
                    Add Attributes
                  </Button>
                ) : ( */}
                  <Row>
                    <Col md={12} xs={12}>
                   
                      <Attributes
                        indexKey={0}
                        attributeData={this.attributeData}
                        matrixData={this.matrixData}
                        postAttributes={this.state.attributes}
                        postMatrix={this.state.metrix}
                        clearStatus={this.state.clearAttributes}
                      />
                    </Col>
                  </Row>
                
                {/* )} */}
              </div>
            </div>
          </div>
          {this.state.priceIndex.map((price, idx) => price)}
          {/**end contract price information **/}

          {/**start contract affiliate information **/}
          {this.state.affiliateOption == true ? (
            <div className="panel">
              <header className="panel-heading">GET ACCESS CONTRACT</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formaffiliatePurchaseUrl">
                        <ControlLabel>Affiliate Purchase URL</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.affiliatePurchaseUrl}
                          name="affiliatePurchaseUrl"
                          placeholder=""
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup controlId="formpaymentType">
                        <ControlLabel>Payment type</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="paymentType"
                          onChange={this.handleChange}
                          value={this.state.paymentType}
                        >
                          <option value="Fixed Fee">Fixed Fee</option>
                          <option value="Pay per voucher">Pay Per Voucher</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formpaymentAmount">
                        <ControlLabel>Payment amount</ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.paymentAmount}
                          placeholder="Amount"
                          onChange={this.handleChange}
                          name="paymentAmount"
                        />
                      </FormGroup>
                      <FormGroup controlId="formpaymentReceived">
                        <ControlLabel>Payment received?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="paymentReceived"
                          onChange={this.handlePaymentReceived}
                          value={this.state.paymentReceived}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                      {this.state.paymentAmountReceivedStatus === true ? (
                        <FormGroup controlId="formpaymentAmountReceived">
                          <ControlLabel>Payment amount received</ControlLabel>
                          <FormControl
                            type="number"
                            value={this.state.paymentAmountReceived}
                            placeholder="paymentAmountReceived"
                            onChange={this.handleChange}
                            name="paymentAmountReceived"
                          />
                        </FormGroup>
                      ) : null}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**start contract affiliate information **/}

          {/**start contract coupon information **/}
          {this.state.coupoOption === true ? (
            <div className="panel">
              <header className="panel-heading">Coupon Options</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formExpirationDate">
                        <ControlLabel>Service</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.service}
                          name="service"
                          placeholder="Service (ex - red, blue)"
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup controlId="formPricing">
                        <ControlLabel>Pricing</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.pricing}
                          placeholder="Pricing ex - (10, 100)"
                          onChange={this.handleChange}
                          name="pricing"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formCreditCardType">
                        <ControlLabel>
                          Merchant Billing Information
                        </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formRetailPrice">
                        <ControlLabel>Credit Card Type</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.creditCardType}
                          placeholder="Credit Card Type"
                          onChange={this.handleChange}
                          name="creditCardType"
                          style={{
                            borderColor: this.state.creditCardTypeError
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Credit Card Number</ControlLabel>
                      <FormGroup
                        controlId="formCreditCardNumber"
                        validationState={this.getValidationcreditCardNumber()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.creditCardNumber}
                          placeholder="Card Mumber"
                          onChange={this.handleChange}
                          name="creditCardNumber"
                          style={{
                            borderColor: this.state.creditCardNumberError
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Expiration Date (MMYY)</ControlLabel>
                      <FormGroup
                        controlId="formCardExpirationDate"
                        validationState={this.getValidationcardExpirationDate()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.cardExpirationDate}
                          placeholder="Expiration Date"
                          onChange={this.handleChange}
                          name="cardExpirationDate"
                          style={{
                            borderColor: this.state.cardExpirationDateError
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Security Code</ControlLabel>
                      <FormGroup
                        controlId="formSecurityNumber"
                        validationState={this.getValidationsecurityNumber()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.securityNumber}
                          placeholder="Security Code"
                          onChange={this.handleChange}
                          name="securityNumber"
                          style={{
                            borderColor: this.state.securityNumberError
                          }}
                          minLength="3"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**end contract coupon information **/}

          {/**start merchant information **/}
          <div className="panel">
            <header className="panel-heading">Merchant Information</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Merchant Name
                    </ControlLabel>
                    <FormGroup
                      controlId="formMerchantID"
                      validationState={this.getValidationmerchantID()}
                    >
                      <FormControl
                        componentClass="select"
                        name="merchantID"
                        onChange={this.handleChangeMerchant}
                        value={this.state.merchantID}
                        style={{ borderColor: this.state.merchantIDError }}
                      >
                        <option value="">Choose Merchant Name</option>
                        {merchantListData.map((el, key) => {
                          return (
                            <option key={key} value={el.merchantID}>
                              {el.merchantName}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formMerchantLegalName">
                      <ControlLabel>Merchant Legal Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.merchantLegalName}
                        placeholder="Minimum Legal Name"
                        onChange={this.handleChange}
                        name="merchantLegalName"
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress1">
                      <ControlLabel>Address 1</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address1}
                        placeholder="Address 1"
                        onChange={this.handleChange}
                        name="address1"
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress2">
                      <ControlLabel>Address 2</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address2}
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        name="address2"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={4} xs={12}>
                    <div className="form-group">
                      <CountryStateCity
                        country={this.state.country}
                        countryName={this.state.countryName}
                        stateAbbr={this.state.state}
                        city={this.state.city}
                        cityId={this.state.cityID}
                        onChange={this.handleChange}
                        onSelectedCountry={this.onSelectedCountry}
                        onSelectedState={this.onSelectedState}
                        onSelectedCity={this.onSelectedCity}
                      />
                      {this.state.countryError ? (
                        <span style={{ color: "red" }}>
                          Select any country!{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      {this.state.stateError ? (
                        <span style={{ color: "red" }}>Select any state! </span>
                      ) : (
                        ""
                      )}
                    </div>

                    <FormGroup controlId="formZipCode">
                      <ControlLabel>Zip Code</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.zip}
                        placeholder="Zip Code"
                        onChange={this.handleChange}
                        name="zip"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      Phone Number (format: xxx-xxx-xxxx)
                    </ControlLabel>
                    <FormGroup
                      controlId="formPhoneNunber"
                      validationState={this.getValidationPhoneState()}
                    >
                       <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={this.state.phone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactName">
                      <ControlLabel>Contact Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.contactName}
                        placeholder="Contact Name"
                        onChange={this.handleChange}
                        name="contactName"
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactPhone">
                      <ControlLabel>Contact Phone</ControlLabel>
                      <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="contactPhone"
                        placeholder="Contact Phone"
                        value={this.state.contactPhone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactEmail">
                      <ControlLabel>Contact Email</ControlLabel>
                      <FormControl
                        type="email"
                        value={this.state.contactEmail}
                        placeholder="Contact Email"
                        onChange={this.handleChange}
                        name="contactEmail"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end merchant information **/}

          {/**start additional option **/}
          {this.state.affiliateOption == false ? (
            <div className="panel">
              <header className="panel-heading">Additional Option</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formRedeemedAtCall">
                        <ControlLabel>
                          {/*Will vouchers be redeemed at will call?*/}
                          Allow this offer to be Gifted?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="redeemedAtCall"
                          onChange={this.handleChange}
                          value={this.state.redeemedAtCall}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                      
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formShipable">
                        <ControlLabel>
                          Will this offer be shipped to the customer?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="shipable"
                          onChange={this.handleChange}
                          value={this.state.shipable}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                   {/* <Col md={4} xs={12}>
                                         <FormGroup controlId="formVouchersBeIssued">
                                           <ControlLabel>
                                             When will the vouchers be issued?
                                           </ControlLabel>
                                           <FormControl
                                             componentClass="select"
                                             name="vouchersBeIssued"
                                             onChange={this.handleChange}
                                             value={this.state.vouchersBeIssued}
                                           >
                                             <option value="instantly">
                                               In real time(instantly)
                                             </option>
                                           </FormControl>
                                         </FormGroup>
                                       </Col>*/}
                    {/*<Col md={4} xs={12}>
                      <FormGroup controlId="formRedemptionCodeReq">
                        <ControlLabel>
                          Are online redemption codes required? 
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="redemptionCodeReq"
                          onChange={this.handleChange}
                          value={this.state.redemptionCodeReq}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                        <span style={{fontSize:'12px', color:'#666'}}>(Choosing this option will give you the option to upload custom coupon codes)</span>
                      </FormGroup>
                    </Col>*/}
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formPaymentTerms">
                        <ControlLabel>
                          Payment terms 
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="payment_term_id"
                          onChange={this.handleChange}
                          value={this.state.payment_term_id}
                          style={{ borderColor: this.state.payment_term_idError }}
                        >
                          <option value="">Choose Option</option>
                          {(this.state.payoutList !== '') &&
                            this.state.payoutList.data.map((data, index) =>
                              <option key={index} value={data.termID}>{data.termName}</option>
                            )
                          }
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>

                </div>
              </div>
            </div>
          ) : null}
          {/**end additional option **/}
          {userinfo.userTypeName !== "salesmanager" ? (
            <div className="panel">
              <header className="panel-heading">Administrative Option</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formControlsSelect">
                        <ControlLabel> Sales Person</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="salesManagerID"
                          value={this.state.salesManagerID}
                          onChange={this.handleChange}
                        >
                          <option>Select Sales Person</option>
                          {salesManagerItems}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="schedule"
                data-key="schedule"
                disabled={this.state.disabled}
                onClick={this.handleSubmit}
              >
                Save
              </Button>
              {/*{aclUtil.checkACL('SCHEDULE_CONTRACT') &&
              <Button
                bsStyle="info"
                type="submit"
                id="schedule"
                data-key="schedule"
                disabled={this.state.disabled}
                onClick={this.handleSubmit}
              >
                Schedule Offer
              </Button>
              }
              {aclUtil.checkACL('PUBLISH_CONTRACT') &&
              <Button
                bsStyle="info"
                type="submit"
                id="execute"
                data-key="publish"
                disabled={this.state.disabled}
                onClick={this.handleSubmit}
              >
                Publish Offer
              </Button>
              } */}
              <Button
                bsStyle="default"
                onClick={() => history.push(`/contractList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    merchantList: state.merchantReducer.merchantList,
    countries: state.countryCityReducers.countries,
    states: state.countryCityReducers.states,
    cityDetailsByState: state.countryCityReducers.cityDetailsByState,
    contractDetails: state.contractReducer.contractDetail,
    updatedContract: state.contractReducer.updatedContract,
    cloneContract: state.contractReducer.cloneContract,
    merchantDetails: state.merchantReducer.merchantDetails,
    sendingMerchantDetails: state.merchantReducer.sendingMerchantDetails,
    addContractResponse: state.contractReducer.addContractResponse,
    error: state.contractReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    salesPersonList: state.salesPersonReducer.salesPersonList,
    payoutList:  state.payoutReducer.payoutList,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    add_contract,
    get_merchant_list,
    renderAlert,
    clearAlert,
    getContractDetails,
    update_contract,
    clone_contract,
    get_merchant_details_id,
    getSalesPersons,
    getPayoutList
  })
)(AddContract);


// WEBPACK FOOTER //
// ./src/app/views/admin/contract/AddContract.js